import projectsData from '../assets/projects.json';
import journeyData from '../assets/life.json';
import profile from '../assets/profile.jpg';

export { profile };

export const bio =
  'CJ Stancin is a robotics & software engineer who builds systems that move — ' +
  'from real-time defense software to automation tooling and full-stack apps. ' +
  'Two tours at Raytheon, a stack that runs from C++ to React, and a habit of ' +
  'shipping side projects for the fun of it.';

export const projects = projectsData;
export const journey = journeyData;

export const experience = [
  {
    org: 'Raytheon Technologies',
    role: 'Software Engineer Intern',
    dates: 'Jun – Aug 2021',
    tactics: [
      'Developed software solutions for real-time systems.',
      'Collaborated cross-functionally to identify software improvements.',
      'Contributed to a security system for military-grade technology.',
    ],
    loot: ['Java', 'Python', 'C++', 'Agile', 'Git'],
  },
  {
    org: 'Raytheon Technologies',
    role: 'Software Engineering Intern',
    dates: 'Jun – Aug 2020',
    tactics: [
      'Designed a new feature for the radar-system software.',
      'Troubleshot and optimized code with senior engineers.',
      'Performed unit testing and bug fixing for software components.',
    ],
    loot: ['C', 'Java', 'Python', 'Embedded Systems', 'Testing'],
  },
];

export const skills = [
  { label: 'Java', icon: 'java' },
  { label: 'Python', icon: 'python' },
  { label: 'C++', icon: 'cpp' },
  { label: 'React', icon: 'react' },
  { label: 'PostgreSQL', icon: 'db' },
  { label: 'HTML5', icon: 'html' },
  { label: 'CSS3', icon: 'css' },
];

export const socials = [
  { label: 'LinkedIn', handle: 'cjstancin', href: 'https://www.linkedin.com/in/cjstancin' },
  { label: 'GitHub', handle: 'cjstancin', href: 'https://www.github.com/cjstancin' },
  { label: 'Instagram', handle: 'cj.stancin', href: 'https://www.instagram.com/cj.stancin' },
];

export const email = 'cj@dimsylaisolutions.com';
